import { render, staticRenderFns } from "./ReconfigureMailMessage.vue?vue&type=template&id=3f07fc22&scoped=true&lang=pug&"
import script from "./ReconfigureMailMessage.vue?vue&type=script&lang=ts&"
export * from "./ReconfigureMailMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ReconfigureMailMessage.vue?vue&type=style&index=0&id=3f07fc22&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f07fc22",
  null
  
)

export default component.exports